<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Amministrazione Trasparente', route: '/backoffice/amministrazione-trasparente/' }, { label: 'Modifica Amministrazione Trasparente', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">MODIFICA FILE AMMINISTRAZIONE TRASPARENTE</h1>
</section>


<section class="pb-16 mb-8 px-container">
    <form [formGroup]="formAmministrazioneTrasparente" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-8">                
            <div class="w-full">
                <label>* Categoria</label>
                <p-dropdown [options]="categorie" optionLabel="categoria" placeholder="Seleziona una categoria" formControlName="categoria"></p-dropdown>
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formAmministrazioneTrasparente.get('categoria')?.hasError('required') && (formAmministrazioneTrasparente.get('categoria')?.dirty || formAmministrazioneTrasparente.get('categoria')?.touched)">La categoria è obbligatoria!.</small>
            </div>     
            <div class="w-full">
                <label>* Titolo</label>
                <input type="text" pInputText placeholder="Titolo" formControlName="titolo" name="titolo" id="titolo" required />
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formAmministrazioneTrasparente.get('titolo')?.hasError('required') && (formAmministrazioneTrasparente.get('titolo')?.dirty || formAmministrazioneTrasparente.get('titolo')?.touched)">Il titolo è obbligatorio!.</small>
            </div>                    
            <div class="w-full">
                <label>* File pdf</label>
                <p-fileUpload mode="advanced" [multiple]="false" chooseLabel="Seleziona un file" accept="application/pdf" maxFileSize="1000000000" cancelLabel="Rimuovi" [showUploadButton]="false" (onSelect)="onPDFUpload($event)" (onRemove)="onRemovePDFUpload($event)" (onClear)="onRemovePDFUpload($event)" />
            </div>  
            <div class="flex lg:flex-row flex-col-reverse gap-8 items-center">
                <div class="lg:w-1/2 w-full">
                    <label>* File pdf</label>
                    <p-fileUpload mode="advanced" [multiple]="false" chooseLabel="Seleziona un file" accept="application/pdf" maxFileSize="1000000000" cancelLabel="Rimuovi" [showUploadButton]="false" (onSelect)="onPDFUpload($event)" (onRemove)="onRemovePDFUpload($event)" (onClear)="onRemovePDFUpload($event)" />
                </div>
                <div class="lg:w-1/2 w-full text-end" *ngIf="file_amministrazione_trasparente?.pdf">
                    <a class="btn-outln-backoffice p-3 lg:w-1/2 w-full font-bold" target="_blank" [href]="file_amministrazione_trasparente?.pdf | pdf">Mostra file caricato</a>                    
                </div>
            </div>              
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="lg:w-1/2 w-full">
                    <button class="btn-outln-backoffice p-3 w-full font-medium" type="submit" [disabled]="!formAmministrazioneTrasparente.valid">Modifica file</button>
                </div>
                <div class="lg:w-1/2 w-full">
                    <p-confirmPopup #confirmPopupRef>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <p-button class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDelete()" label="Elimina" />
                                    <p-button class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onAnnulla()" label="Annulla" />
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmPopup>
                    <button class="btn-danger-backoffice p-3 w-full font-medium" type="button" (click)="onDeletePopup($event)">Elimina file</button>
                </div>
            </div>    
        </div>
    </form>
</section>